// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/data/common/svg/info.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoLink {
  color: inherit;
  display: inline-flex;
  flex-shrink: 0;
  vertical-align: middle;
}

.infoLink:hover,
.infoLink:focus-visible {
  opacity: 1;
}

.infoLinkIcon {
  background-color: currentColor;
  display: block;
  height: 15px;
  width: 15px;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/InfoLink.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mDAA4C;EAC5C,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".infoLink {\n  color: inherit;\n  display: inline-flex;\n  flex-shrink: 0;\n  vertical-align: middle;\n}\n\n.infoLink:hover,\n.infoLink:focus-visible {\n  opacity: 1;\n}\n\n.infoLinkIcon {\n  background-color: currentColor;\n  display: block;\n  height: 15px;\n  width: 15px;\n  mask-image: url('/data/common/svg/info.svg');\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
